import { compact, uniq } from 'lodash-es';
import type { Security } from '../../../types/Security';

export interface QtyInputCurrencyOptions<KeyType = string> {
  currency: KeyType;
  label: string;
  description?: string;
}

export function getDefaultCurrencyOptions(security: Security | undefined): QtyInputCurrencyOptions[] {
  if (!security) {
    return [];
  }

  const { BaseCurrency, QuoteCurrency } = security;
  return uniq(compact([BaseCurrency, QuoteCurrency])).map(currency => ({
    currency,
    label: currency,
  }));
}
